import { ComponentType } from 'react';
import EmailIcon from '../components/common/icons/Email';
import GitHubIcon from '../components/common/icons/GitHub';
import LinkedInIcon from '../components/common/icons/LinkedIn';
import NPMIcon from '../components/common/icons/NPM';
import TwitterIcon from '../components/common/icons/Twitter';
import { links } from '../const';

export const contactLinks = {
  email: 'm.n.koparanov@gmail.com',
  linkedin: 'https://linkedin.com/in/martin-koparanov/',
  github: 'https://github.com/onestopjs',
  npm: 'https://npmjs.com/~onestopjs',
  twitter: 'https://twitter.com/onestopjs'
};

export const age = 27;
export const yearsOfExperience = 11;

interface NavLink {
  text: string;
  to: string;
}

interface ContactLink {
  icon: ComponentType;
  text: string;
  href: string;
  underlineClassName?: string;
}

export const navLinks: NavLink[] = [
  { text: 'Home', to: links.home },
  { text: 'What I Do', to: links.whatIDo },
  { text: 'Selected Projects', to: links.selectedWork },
  { text: 'About', to: links.about },
  { text: 'Contact', to: links.contact }
];

export const contacts: ContactLink[] = [
  {
    icon: EmailIcon,
    text: contactLinks.email,
    href: `mailto:${contactLinks.email}`
  },
  {
    icon: LinkedInIcon,
    text: 'Martin Koparanov',
    href: contactLinks.linkedin,
    underlineClassName: 'mt-1'
  },
  {
    icon: GitHubIcon,
    text: 'onestopjs',
    href: contactLinks.github,
    underlineClassName: 'mt-1'
  },
  {
    icon: NPMIcon,
    text: 'onestopjs',
    href: contactLinks.npm
  },
  {
    icon: TwitterIcon,
    text: 'onestopjs',
    href: contactLinks.twitter
  }
];
